import React from 'react';
import ConnectedModal from 'containers/ConnectedModal';
import AICaptionsUpsellModalContents from './AICaptionsUpsellModalContents';

const AICaptionsUpsellModal: React.FC = () => (
  <ConnectedModal name="AICaptionsUpsell" title="Your personal copywriter">
    <AICaptionsUpsellModalContents />
  </ConnectedModal>
);

export default AICaptionsUpsellModal;
